var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "40px",
    height: "40px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M40 20c0,-11.05 -8.95,-20 -20,-20 -11.05,0 -20,8.95 -20,20 0,11.05 8.95,20 20,20 11.05,0 20,-8.95 20,-20zm-20 -1.61c-0.85,0 -1.67,-0.34 -2.27,-0.94 -0.6,-0.6 -0.94,-1.42 -0.94,-2.27 0,-0.85 0.34,-1.67 0.94,-2.27 0.6,-0.61 1.42,-0.95 2.27,-0.95 0.86,0 1.67,0.34 2.28,0.95 0.6,0.6 0.93,1.42 0.93,2.27 0,0.85 -0.33,1.67 -0.93,2.27 -0.61,0.6 -1.42,0.94 -2.28,0.94zm-7.5 9.65c0,-0.99 0.19,-1.96 0.57,-2.88 0.38,-0.9 0.93,-1.73 1.63,-2.43 0.69,-0.7 1.52,-1.25 2.43,-1.62 0.91,-0.38 1.89,-0.57 2.87,-0.57 0.99,0 1.96,0.19 2.87,0.57 0.91,0.37 1.74,0.92 2.43,1.62 0.7,0.7 1.25,1.53 1.63,2.43 0.38,0.92 0.57,1.89 0.57,2.88l-15 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/user_profile_icon.032a204623a6a7ac2f52fc6ec23b0d2c.svg";
export { ForwardRef as ReactComponent };